$component-class: 'me-column';

.#{$component-class} {
  flex: 1 1 0;
  max-width: 100%;
}

@mixin generate-column-spans($component-class, $steps: 12) {
  @for $i from 1 through $steps {
    $percent: calc(($i / $steps) * 100%);

    .#{$component-class}--span-#{$i} {
      flex: 0 0 $percent;
      max-width: $percent;
    }
  }

  @for $i from 1 through $steps {
    $percent: calc(($i / $steps) * 100%);

    .#{$component-class}--span-md-#{$i} {
      @include desktop {
        flex: 0 0 $percent;
        max-width: $percent;
      }
    }
  }

  @for $i from 1 through $steps {
    $percent: calc(($i / $steps) * 100%);

    .#{$component-class}--span-lg-#{$i} {
      @include desktop-lg {
        flex: 0 0 $percent;
        max-width: $percent;
      }
    }
  }
}

@include generate-column-spans($component-class, 12);

.#{$component-class}--span-auto {
  @include grid-column-auto;
}

.#{$component-class}--span-md-auto {
  @include desktop {
    @include grid-column-auto;
  }
}

.#{$component-class}--span-lg-auto {
  @include desktop-lg {
    @include grid-column-auto;
  }
}
